<template>
  <div id="zc">
      <div class="lleft">
          <div class="logo">
                <img src="@/assets/logo2.png"  @click="$router.push('/')">
                <div>欢迎访问智能医学科研方案设计平台</div>
           </div> 
           <div class="copy">CopyRight 2012-2025 All Right Reserved 天创明达CreateMed </div>
      </div>
      <div class="lright">
            <div class="rightbox">
                <div class="tit">智能医学科研方案设计平台账号注册</div>
               <el-form ref="form" :rules="rules" class="mt_30" :model="form" label-width="140px" label-position="right">
                    <el-form-item label="用户名：" prop="username">
                        <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码：" prop="password">
                        <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
                    </el-form-item>
                     <el-form-item label="再次输入：" prop="password2">
                        <el-input v-model="form.password2" type="password" placeholder="请再次输入密码"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：" prop="mobile">
                        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱：" prop="email">
                        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="机构或公司：" prop="jggs">
                        <el-input v-model="form.jggs" placeholder="请输入机构或公司"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="realname">
                        <el-input v-model="form.realname" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号：" prop="wxh">
                        <el-input v-model="form.wxh" placeholder="请输入微信号"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <div class="flex flex-v">
                       <el-checkbox v-model="checked"></el-checkbox><span class="ml_10 f18">我已阅读并同意<router-link target="_blank" to="/artice?id=1">《用户注册协议》</router-link></span>
                            </div>
                    </el-form-item>
                    <el-form-item label="">
                       <el-button class="logbtn" :disabled="!checked&&isclick" type="primary" @click="send">提交注册</el-button>
                    </el-form-item>
                </el-form>
                
               
               
            </div>
      </div>

     
  </div>
</template>

<script>
import { register } from "@/api/index.js"
export default {
  name: "Login",
  data() {
    return {
      isclick:false,
      form:{
       username:'',
        password:'',
        password2:'',
        mobile:'',
        email:'',
        jggs:'',
        realname:'',
        wxh:'',
      },
      rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
         password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          password2: [
            { required: true, message: '请再次输入密码', trigger: 'blur' }
          ],
           mobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ],
           email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' }
          ],
           jggs: [
            { required: true, message: '请输入机构或公司', trigger: 'blur' }
          ],
           realname: [
            { required: true, message: '请输入真实姓名', trigger: 'blur' }
          ],
          wxh: [
            { required: true, message: '请输入微信号', trigger: 'blur' }
          ],
        },
      dialogVisible:false,
      dialogVisible2:false,
       checked: true
    }
  },
  methods:{
    zhmm(){
      this.dialogVisible=false;
      this.dialogVisible2=true;
    },
    send(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.isclick=true;
            register(this.form).then(res=>{
        if(res.code==1){
           this.$message({
                    message: '注册成功',
                    type: 'success'
            });
            this.$router.push('/login')
            this.isclick=false
        }
      })
            
          } 
        });
      
    }
  }
};
</script>

<style lang="less">
#zc {
  display: flex;position: absolute;top:0;left:0;right:0;bottom:0;
   .lleft {
    background:#F4F8FC;flex:4;height:100%;display:flex;justify-content: center;align-items:center; flex-direction:  column;
    .logo {margin-bottom:100px;
      font-size: 18px;text-align:center;height:calc(100% - 200px);display:flex;justify-content: center;align-items:center; flex-direction:  column;
      img {width:140px;margin-bottom:20px;cursor:pointer}
    }
    .copy {color:#7A7A7A;font-size:14px;text-align: center;}
  }
  .lright {
    flex:6;border-left:1px solid #D1D1D1;height:100%;display:flex;justify-content: center;align-items:center;
    .rightbox {
     display:flex;justify-content: center;flex-direction:  column;text-align: left;
    }
    .tit {
      font-size:24px;font-weight: bold;padding-left:140px;
    }
    .dlfont {font-size:20px;font-weight: bold}
    .inp {width:100%;;margin-top:10px;
        .el-input__inner {
          height:50px;font-size:18px;border:1px solid #D3D3D3;
        }
    }
    .logbtn {
     width:100%;
height: 60x;
background: #2397CA;
border-radius: 6px;font-size:22px;
    }
    .linkfont {color:#2397CA;font-weight: bold;font-size: 16px;cursor: pointer;}
  }
   .tipfont {font-size:18px;font-weight: bold}


   .el-form {
        .el-form-item {
            .el-form-item__label {font-size: 18px;font-weight: bold;line-height: 50px;}
            .el-input__inner {width:450px;height:50px;font-size: 18px;border:1px solid #ccc;border-radius: 6px;}
        }
        
   }
}
</style>
